import { useUntypedModalContext } from 'react-easyrocket';
import { ModalMapKeys } from 'src/modals/config';

export const useModalContext = <ModalPropsType>() =>
  useUntypedModalContext<ModalMapKeys, ModalPropsType>();
